import Navbar from "./Navbar";

function Header() {
    return <Navbar></Navbar>;
}

export default Header;
